export default "__VITE_ASSET__B_4S6NtA__"